import amber from '@material-ui/core/colors/amber'
import green from '@material-ui/core/colors/green'
import IconButton from '@material-ui/core/IconButton'
import Snackbar from '@material-ui/core/Snackbar'
import SnackbarContent from '@material-ui/core/SnackbarContent'
import { withStyles } from '@material-ui/core/styles'
import CheckCircleIcon from '@material-ui/icons/CheckCircle'
import CloseIcon from '@material-ui/icons/Close'
import ErrorIcon from '@material-ui/icons/Error'
import InfoIcon from '@material-ui/icons/Info'
import WarningIcon from '@material-ui/icons/Warning'
import * as classNames from 'classnames'
import * as PropTypes from 'prop-types'
import * as React from 'react'

import SnackbarService from '../../services/snackbars'

const variantIcon = {
  success: CheckCircleIcon,
  warning: WarningIcon,
  error: ErrorIcon,
  info: InfoIcon
}

const styles1 = theme => ({
  base: {
    display: 'flex',
    flexDirection: 'row' as 'row',
    flexWrap: 'nowrap' as 'nowrap',
    paddingTop: 'calc(6px + env(safe-area-inset-top))'
  },
  success: {
    backgroundColor: green[600]
  },
  error: {
    backgroundColor: theme.palette.error.dark
  },
  info: {
    backgroundColor: theme.palette.primary.dark
  },
  warning: {
    backgroundColor: amber[700]
  },
  icon: {
    fontSize: '2rem'
  },
  iconVariant: {
    opacity: 0.9,
    marginRight: theme.spacing.unit
  },
  message: {
    display: 'flex',
    alignItems: 'center',
    textAlign: 'left' as 'left',
    fontSize: '1.65rem',
    lineHeight: '1.3em'
  }
})

function MySnackbarContent(props) {
  const { classes, className, message, onClose, variant, ...other } = props
  const Icon = variantIcon[variant]

  return (
    <SnackbarContent
      className={classNames(classes[variant], className, classes.base)}
      aria-describedby="client-snackbar"
      message={
        <span id="client-snackbar" className={classes.message}>
          <Icon className={classNames(classes.icon, classes.iconVariant)} />
          {message}
        </span>
      }
      action={[
        <IconButton
          key="close"
          aria-label="Close"
          color="inherit"
          className={classes.close}
          onClick={onClose}
        >
          <CloseIcon className={classes.icon} />
        </IconButton>
      ]}
      {...other}
    />
  )
}

MySnackbarContent.propTypes = {
  classes: PropTypes.object.isRequired,
  className: PropTypes.string,
  message: PropTypes.node,
  onClose: PropTypes.func,
  variant: PropTypes.oneOf(['success', 'warning', 'error', 'info']).isRequired
}

const MySnackbarContentWrapper = withStyles(styles1)(MySnackbarContent)

const styles2 = theme => ({
  margin: {
    margin: theme.spacing.unit
  }
})

class CustomizedSnackbars extends React.Component {
  state = {
    open: false,
    type: 'success',
    message: '',
    keepOpen: false
  }

  componentDidMount() {
    SnackbarService.showSnackbar = this.handleClick
    SnackbarService.close = this.close
    SnackbarService.setKeepOpen = this.setKeepOpen
  }

  handleClick = (message, type, keepOpen: boolean = false) => {
    this.setState({
      open: true,
      type,
      message,
      keepOpen
    })
  }

  handleClose = (event, reason) => {
    if (reason === 'clickaway') {
      return
    }

    this.close()
  }

  close = () => {
    this.setState({ open: false, keepOpen: false })
  }

  setKeepOpen = (keepOpen: boolean) => this.setState({ keepOpen })

  render() {
    const { open, type, message, keepOpen } = this.state
    return (
      <Snackbar
        anchorOrigin={{
          vertical: 'top',
          horizontal: 'right'
        }}
        open={open}
        autoHideDuration={keepOpen ? undefined : 4000}
        onClose={this.handleClose}
      >
        <MySnackbarContentWrapper
          onClose={this.handleClose}
          variant={type}
          message={message}
        />
      </Snackbar>
    )
  }
}

export default withStyles(styles2)(CustomizedSnackbars)



// WEBPACK FOOTER //
// ./src/components/Snackbars/index.tsx